import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Card,
  Button,
  Table,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  CardTitle,
  CardHeader,
  Label,
  Alert,
} from "reactstrap";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import Cookies from "js-cookie";
import { api } from "api";

// Add custom styles for calendar - matching dashboard exactly - FIXED
const calendarCustomStyle = `
.react-calendar__tile--active,
.react-calendar__tile--range,
.react-calendar__tile--rangeStart,
.react-calendar__tile--rangeEnd {
  background: #d86f89 !important;
  color: #fff !important;
}
`;

const AttendancePage = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [selectedDeliveryProject, setSelectedDeliveryProject] = useState("");
  const [selectedReturnProject, setSelectedReturnProject] = useState("");
  const [deliveryProjectDropdownOpen, setDeliveryProjectDropdownOpen] =
    useState(false);
  const [returnProjectDropdownOpen, setReturnProjectDropdownOpen] =
    useState(false);
  const [projects, setProjects] = useState([]);
  // const [deliveryProductDropdownOpen, setDeliveryProductDropdownOpen] = useState(false);
  // const [returnProductDropdownOpen, setReturnProductDropdownOpen] = useState(false);

  const [addStockMessage, setAddStockMessage] = useState({
    type: "",
    text: "",
  });

  const [monthFilter, setMonthFilter] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [dateFilter, setDateFilter] = useState(""); // Add date filter state
  const [dateSortOrder, setDateSortOrder] = useState("desc"); // Add date sorting state
  const [calendarModalOpen, setCalendarModalOpen] = useState(false);
  const [selectedCalendarDate, setSelectedCalendarDate] = useState(null);

  const [attendanceData, setAttendanceData] = useState([]);
  const [entriesToShow, setEntriesToShow] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  // Fetch attendance data
  useEffect(() => {
    const fetchAttendanceData = async () => {
      try {
        const response = await api.get(`empAttendance.php?company_id=${Cookies.get('company_id')}`);
        if (response.data.status === "success") {
          setAttendanceData(response.data.attendance);
          setFilteredData(response.data.attendance);
        }
      } catch (error) {
        console.error("Error fetching attendance data:", error);
      }
    };

    fetchAttendanceData();
  }, []);

  const [itemToDelete, setItemToDelete] = useState(null);

  const handleDeleteIconClick = (item_id) => {
    setItemToDelete(item_id);
    setShowDeleteConfirmation(true);
  };



  const [showRoleModal, setShowRoleModal] = useState(false);
  const [showRoleModal2, setShowRoleModal2] = useState(false);
  const [showRoleModal3, setShowRoleModal3] = useState(false);
  const toggleRole = () => {
    setShowRoleModal(!showRoleModal);
  };
  const toggleRole2 = () => {
    setShowRoleModal2(!showRoleModal2);
  };
  const toggleRole3 = () => {
    setShowRoleModal3(!showRoleModal3);
  };

  const [role, setrole] = useState();

  const [viewrole, setviewrole] = useState();
  const [loading, setLoading] = useState(true);

  const totalPages = Math.ceil(filteredData.length / entriesToShow);

  const getSerialNumber = (index) => {
    return (currentPage - 1) * entriesToShow + index + 1;
  };



  const toggleProjectDropdown = () => {
    setProjectDropdownOpen(!projectDropdownOpen);
  };

  const handleEntriesChange = (value) => {
    const newEntriesToShow = value === "All" ? filteredData.length : Number(value);
    setEntriesToShow(newEntriesToShow);
    setCurrentPage(1);
    setDropdownOpen(false); // Close the dropdown after selection
  };

  const prePage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const changeCPage = (n) => {
    setCurrentPage(n);
  };

  // Get unique values for filters
  const uniqueNames = Array.from(new Set(attendanceData.map(item => item.emp_name)));
  const uniqueStatuses = Array.from(new Set(attendanceData.map(item => item.status)));

  // Extract unique dates for date filter
  const uniqueDates = Array.from(
    new Set(
      attendanceData
        .map(item => item.date)
        .filter(date => date)
        .sort((a, b) => new Date(b) - new Date(a)) // Sort dates in descending order
    )
  );

  // Month names array
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  // 1. Add state for year filter
  const [yearFilter, setYearFilter] = useState("");

  // 2. Extract unique years from attendanceData
  const uniqueYears = Array.from(
    new Set(
      attendanceData
        .map(item => item.date && new Date(item.date).getFullYear())
        .filter(year => year)
    )
  );

  // Date sorting function
  const sortByDate = (data, order) => {
    return [...data].sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return order === "desc" ? dateB - dateA : dateA - dateB;
    });
  };

  // Filter logic
  useEffect(() => {
    let filteredResults = attendanceData;

    if (searchQuery) {
      filteredResults = filteredResults.filter(
        (item) =>
          item.emp_name &&
          item.emp_name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    if (monthFilter) {
      filteredResults = filteredResults.filter(item => {
        if (!item.date) return false;
        const date = new Date(item.date);
        if (isNaN(date)) return false;
        const monthName = monthNames[date.getMonth()];
        return monthName === monthFilter;
      });
    }

    // Year filter logic
    if (yearFilter) {
      filteredResults = filteredResults.filter(item => {
        if (!item.date) return false;
        const date = new Date(item.date);
        if (isNaN(date)) return false;
        return date.getFullYear().toString() === yearFilter;
      });
    }

    if (nameFilter) {
      filteredResults = filteredResults.filter(item => item.emp_name === nameFilter);
    }

    if (statusFilter) {
      filteredResults = filteredResults.filter(item => item.status === statusFilter);
    }

    // Date filter logic
    if (dateFilter) {
      filteredResults = filteredResults.filter(item => item.date === dateFilter);
    }

    // Apply date sorting
    filteredResults = sortByDate(filteredResults, dateSortOrder);

    setFilteredData(filteredResults);
  }, [searchQuery, attendanceData, monthFilter, yearFilter, nameFilter, statusFilter, dateFilter, dateSortOrder]);

  // Handle date sort toggle
  const handleDateSort = () => {
    setDateSortOrder(prevOrder => prevOrder === "desc" ? "asc" : "desc");
  };

  // Clear all filters
  const clearAllFilters = () => {
    setSearchQuery("");
    setMonthFilter("");
    setYearFilter("");
    setNameFilter("");
    setStatusFilter("");
    setDateFilter("");
    setDateSortOrder("desc");
    setSelectedCalendarDate(null);
  };

  // Handle calendar date selection
  const handleCalendarDateChange = (date) => {
    setSelectedCalendarDate(date);
    // Format date to YYYY-MM-DD format
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    setDateFilter(formattedDate);
    setCalendarModalOpen(false);
  };

  // Open calendar modal
  const openCalendarModal = () => {
    setCalendarModalOpen(true);
  };

  // Close calendar modal
  const closeCalendarModal = () => {
    setCalendarModalOpen(false);
  };

  // Check if a date has attendance data
  const hasAttendanceOnDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateStr = `${year}-${month}-${day}`;
    return attendanceData.some(item => item.date === dateStr);
  };

  // Format date for display - keep original YYYY-MM-DD format
  const formatDate = (dateString) => {
    if (!dateString) return "";
    // Return the original date string as is (YYYY-MM-DD format)
    return dateString;
  };

  // Excel download
  const handleDownload = () => {
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "attendance_list";

    const formattedData = filteredData
      .slice((currentPage - 1) * entriesToShow, currentPage * entriesToShow)
      .map((item, index) => ({
        "SI.No": getSerialNumber(index),
        "Employee Name": item.emp_name,
        "Date": formatDate(item.date),
        "Time In": item.time_in,
        "Time Out": item.time_out,
        "Status": item.status,
        "Total Hours": item.total_hours
      }));

    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Attendance List");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelData = new Blob([excelBuffer], { type: fileType });
    const excelUrl = URL.createObjectURL(excelData);
    const link = document.createElement("a");
    link.href = excelUrl;
    link.download = fileName + fileExtension;
    document.body.appendChild(link);
    link.click();
    setTimeout(function () {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(excelUrl);
    }, 100);
  };

  const [addstock, setAddStock] = useState({
    product_name: "",
    total_stock: 0,
    available_stock: 0,
    cost: "",
  });

  const [addstock2, setAddStock2] = useState({
    p_id: "",
    product_name: "",
    quantity_delivered: "",
    delivery_date: "",
    delivered_to_name: "",
    product_cost: "",
    material_tracking_number: "",
  });

  const [addstock3, setAddStock3] = useState({
    p_id: "",
    product_name: "",
    quantity_returned: "",
    yet_to_returned: "",
    return_date: "",
    returned_by: "",
    material_tracking_number: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAddStock((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setAddStock2((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setAddStock3((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    console.log("Updated form data:", { ...addstock, [name]: value }); // Debug log
  };





  const [projectDropdownOpen2, setProjectDropdownOpen2] = useState(false);

  const toggleProjectDropdown2 = () => {
    setProjectDropdownOpen2(!projectDropdownOpen2);
  };

  const handleRequestOptionChange = (e) => {
    setRequestOption(e.target.value);
    if (e.target.value === "single") {
      toggleRole();
    } else if (e.target.value === "multiple") {
      toggleModalImport();
    }
  };
  const [requestOption, setRequestOption] = useState("");
  const toggleModalAdd = () => setModalAdd(!modalAdd);
  const [modalAdd, setModalAdd] = useState(false);
  const [importedFile, setImportedFile] = useState(null);
  const emp_id = Cookies.get("token") || Cookies.get("emp_id");

  const [reqmaterial, setReqmaterial] = useState({
    emp_id: emp_id || "",
    p_id: "",
    files: [],
    g_m_id: "",
  });

  const handleImportFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setImportedFileDetails({
        fileName: file.name,
        uploadTime: new Date().toLocaleTimeString(),
      });
      setUploadMessage({ type: "", text: "" }); // Clear previous messages
    } else {
      setSelectedFile(null);
      setImportedFileDetails(null);
    }
  };

  const [modalImport, setModalImport] = useState(false); // State to control modal visibility
  const [selectedFile, setSelectedFile] = useState(null); // State to hold the File object
  const [importedFileDetails, setImportedFileDetails] = useState(null); // State for display info
  const [isUploading, setIsUploading] = useState(false); // State for loading indicator
  const [uploadMessage, setUploadMessage] = useState({ type: "", text: "" }); // State for feedback

  const toggleModalImport = () => {
    setModalImport(!modalImport);
    // Reset states when closing modal
    if (modalImport) {
      setSelectedFile(null);
      setImportedFileDetails(null);
      setUploadMessage({ type: "", text: "" });
      setIsUploading(false);
    }
  };

  // Handle file selection

  // Handle form submission


  // Add these state declarations after your existing state declarations
  const [materialDeliveryData, setMaterialDeliveryData] = useState([]);
  const [filteredMaterialDeliveryData, setFilteredMaterialDeliveryData] =
    useState([]);
  const [deliveryEntriesToShow, setDeliveryEntriesToShow] = useState(5);
  const [deliveryCurrentPage, setDeliveryCurrentPage] = useState(1);
  const [deliveryShowEntriesDropdownOpen, setDeliveryShowEntriesDropdownOpen] =
    useState(false);

  const [vendorReturnData, setVendorReturnData] = useState([]);
  const [filteredVendorReturnData, setFilteredVendorReturnData] = useState([]);
  const [returnEntriesToShow, setReturnEntriesToShow] = useState(5);
  const [returnCurrentPage, setReturnCurrentPage] = useState(1);
  const [returnShowEntriesDropdownOpen, setReturnShowEntriesDropdownOpen] =
    useState(false);

  // Add these useEffect hooks after your existing useEffects



  // Add these handlers after your existing handlers
  const handleDeliveryEntriesChange = (value) => {
    setDeliveryEntriesToShow(
      value === "All" ? filteredMaterialDeliveryData.length : Number(value)
    );
    setDeliveryCurrentPage(1);
  };

  const deliveryPrevPage = () => {
    if (deliveryCurrentPage > 1) {
      setDeliveryCurrentPage(deliveryCurrentPage - 1);
    }
  };

  const deliveryNextPage = () => {
    if (
      deliveryCurrentPage <
      Math.ceil(filteredMaterialDeliveryData.length / deliveryEntriesToShow)
    ) {
      setDeliveryCurrentPage(deliveryCurrentPage + 1);
    }
  };

  const handleReturnEntriesChange = (value) => {
    setReturnEntriesToShow(
      value === "All" ? filteredVendorReturnData.length : Number(value)
    );
    setReturnCurrentPage(1);
  };

  const returnNextPage = () => {
    if (
      returnCurrentPage <
      Math.ceil(filteredVendorReturnData.length / returnEntriesToShow)
    ) {
      setReturnCurrentPage(returnCurrentPage + 1);
    }
  };

  const returnPrevPage = () => {
    if (returnCurrentPage > 1) {
      setReturnCurrentPage(returnCurrentPage - 1);
    }
  };

  // Add this useEffect to fetch projects

  // Add these filter handlers
  const handleDeliveryProjectFilter = (projectId) => {
    setSelectedDeliveryProject(projectId);
    if (!projectId) {
      setFilteredMaterialDeliveryData(materialDeliveryData);
    } else {
      const filtered = materialDeliveryData.filter(
        (item) => item.p_id === projectId
      );
      setFilteredMaterialDeliveryData(filtered);
    }
    setDeliveryCurrentPage(1);
  };

  const handleReturnProjectFilter = (projectId) => {
    setSelectedReturnProject(projectId);
    if (!projectId) {
      setFilteredVendorReturnData(vendorReturnData);
    } else {
      const filtered = vendorReturnData.filter(
        (item) => item.p_id === projectId
      );
      setFilteredVendorReturnData(filtered);
    }
    setReturnCurrentPage(1);
  };

  // Add these state declarations after your existing state declarations
  const [deliveryProductDropdownOpen, setDeliveryProductDropdownOpen] =
    useState(false);
  const [returnProductDropdownOpen, setReturnProductDropdownOpen] =
    useState(false);

  // Add these toggle functions after your existing handlers
  const toggleDeliveryProjectDropdown = () => {
    setDeliveryProjectDropdownOpen(!deliveryProjectDropdownOpen);
  };

  const toggleReturnProjectDropdown = () => {
    setReturnProjectDropdownOpen(!returnProjectDropdownOpen);
  };

  // Update the handleDeleteIconClick function for Material Delivery

  // Add these state declarations for Material Return
  const [materialDeliveryProducts, setMaterialDeliveryProducts] = useState([]);
  const [selectedProductProjects, setSelectedProductProjects] = useState([]);
  const [selectedProjectTracking, setSelectedProjectTracking] = useState([]);

  // Add this useEffect to fetch Material Delivery products

  // Add this function to handle product selection
  const handleProductSelect = (productName) => {
    setAddStock3((prev) => ({
      ...prev,
      product_name: productName,
      p_id: "", // Reset project selection
      material_tracking_number: "", // Reset tracking number
    }));

    // Filter projects for selected product
    const projects = materialDeliveryProducts
      .filter((item) => item.product_name === productName)
      .map((item) => ({
        p_id: item.p_id,
        p_name: item.p_name,
      }));
    setSelectedProductProjects(projects);
  };

  // Add these state declarations
  const [selectedDeliveryInfo, setSelectedDeliveryInfo] = useState(null);

  // Update the handleProjectSelect function to include client names
  const handleProjectSelect = (p_id) => {
    setAddStock3((prev) => ({
      ...prev,
      p_id: p_id,
      material_tracking_number: "", // Reset tracking number
      returned_by: "", // Reset returned by
    }));

    // Filter tracking numbers and get delivery info for selected product and project
    const deliveryInfo = materialDeliveryData
      .filter(
        (item) =>
          item.product_name === addstock3.product_name && item.p_id === p_id
      )
      .map((item) => ({
        material_tracking_number: item.material_tracking_number,
        delivered_to_name: item.delivered_to_name,
        quantity_delivered: item.quantity_delivered,
      }));
    setSelectedProjectTracking(deliveryInfo);
  };

  // Add the handleTrackingNumberSelect function
  const handleTrackingNumberSelect = (trackingNumber) => {
    setAddStock3((prev) => ({
      ...prev,
      material_tracking_number: trackingNumber,
    }));

    // Find the delivery info for the selected tracking number
    const deliveryInfo = selectedProjectTracking.find(
      (item) => item.material_tracking_number === trackingNumber
    );
    setSelectedDeliveryInfo(deliveryInfo);
  };

  // Update the Material Tracking Number and Quantity Returned fields in the form
  <Row className="mb-4">
    <Col md={6}>
      <label className="form-control-label" htmlFor="input-role">
        Material Tracking Number
      </label>
      <select
        name="material_tracking_number"
        className="form-select form-control-alternative custom-select"
        id="input-role"
        onChange={(e) => handleTrackingNumberSelect(e.target.value)}
        required
        disabled={!addstock3.p_id}
        style={{
          padding: "0.75rem 1rem",
          fontSize: "0.875rem",
          fontWeight: "400",
          lineHeight: "1.5",
          color: "#495057",
          backgroundColor: "#fff",
          backgroundClip: "padding-box",
          border: "1px solid #ced4da",
          borderRadius: "0.375rem",
          transition:
            "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
          height: "calc(2.75rem + 2px)",
          width: "100%",
        }}
      >
        <option value="">Select Tracking Number</option>
        {selectedProjectTracking.map((item, index) => (
          <option
            key={index}
            value={item.material_tracking_number}
            style={{
              padding: "0.5rem 1rem",
              fontSize: "0.875rem",
            }}
          >
            {item.material_tracking_number}
          </option>
        ))}
      </select>
      {selectedDeliveryInfo && (
        <div className="mt-2">
          <small className="text-muted">
            Delivered to: {selectedDeliveryInfo.delivered_to_name}
          </small>
        </div>
      )}
    </Col>
    <Col md={6}>
      <label className="form-control-label" htmlFor="input-role">
        Enter Quantity Returned
      </label>
      <Input
        className="form-control-alternative"
        id="input-role"
        type="number"
        name="quantity_returned"
        onChange={handleInputChange}
        placeholder="Enter Quantity Returned"
        required
      />
      {selectedDeliveryInfo && (
        <div className="mt-2">
          <small className="text-muted">
            Available Stock: {selectedDeliveryInfo.quantity_delivered}
          </small>
        </div>
      )}
    </Col>
  </Row>;

  // Update the Material Return form JSX

  // Add the handleDeleteReturn function


  // Add state for delivery and return search queries
  const [deliverySearchQuery, setDeliverySearchQuery] = useState("");
  const [returnSearchQuery, setReturnSearchQuery] = useState("");

  // Filter logic for Material Delivery List
  useEffect(() => {
    if (deliverySearchQuery === "") {
      setFilteredMaterialDeliveryData(materialDeliveryData);
    } else {
      const filteredResults = materialDeliveryData.filter(
        (item) =>
          (item.product_name && item.product_name.toLowerCase().includes(deliverySearchQuery.toLowerCase())) ||
          (item.p_name && item.p_name.toLowerCase().includes(deliverySearchQuery.toLowerCase())) ||
          (item.delivered_to_name && item.delivered_to_name.toLowerCase().includes(deliverySearchQuery.toLowerCase())) ||
          (item.material_tracking_number && item.material_tracking_number.toLowerCase().includes(deliverySearchQuery.toLowerCase()))
      );
      setFilteredMaterialDeliveryData(filteredResults);
    }
  }, [deliverySearchQuery, materialDeliveryData]);

  // Filter logic for Material Return List
  useEffect(() => {
    if (returnSearchQuery === "") {
      setFilteredVendorReturnData(vendorReturnData);
    } else {
      const filteredResults = vendorReturnData.filter(
        (item) =>
          (item.product_name && item.product_name.toLowerCase().includes(returnSearchQuery.toLowerCase())) ||
          (item.p_name && item.p_name.toLowerCase().includes(returnSearchQuery.toLowerCase())) ||
          (item.returned_by && item.returned_by.toLowerCase().includes(returnSearchQuery.toLowerCase())) ||
          (item.material_tracking_number && item.material_tracking_number.toLowerCase().includes(returnSearchQuery.toLowerCase()))
      );
      setFilteredVendorReturnData(filteredResults);
    }
  }, [returnSearchQuery, vendorReturnData]);

  return (
    <>
      <style>{calendarCustomStyle}</style>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <div className="header bg-gradient-info py-5">
            <Container fluid>
              <Row className="mb-5">
  <Col xs="12">
    {/* Tablet View - Column layout */}
    <div className="d-none d-md-flex d-lg-none flex-column">
      {/* Search Bar */}
      <Form className="navbar-search form-inline w-100 mb-3">
        <FormGroup className="mb-0 w-100">
          <div className="d-flex align-items-center">
            <InputGroup className="input-group-alternative flex-grow-1">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="fas fa-search" style={{ color: "black" }} />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                placeholder="Search Employee"
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </InputGroup>
          </div>
        </FormGroup>
      </Form>

      {/* Filters */}
      <div className="row">
        <div className="col-md-6 mb-3">
          <select
            className="form-select form-control-alternative custom-select w-100"
            value={monthFilter}
            onChange={(e) => setMonthFilter(e.target.value)}
          >
            <option value="">Months</option>
            {monthNames.map((month) => (
              <option key={month} value={month}>
                {month}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-6 mb-3">
          <select
            className="form-select form-control-alternative custom-select w-100"
            value={yearFilter}
            onChange={(e) => setYearFilter(e.target.value)}
          >
            <option value="">Years</option>
            {uniqueYears.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-6 mb-3">
          <select
            className="form-select form-control-alternative custom-select w-100"
            value={nameFilter}
            onChange={(e) => setNameFilter(e.target.value)}
          >
            <option value="">Employee Names</option>
            {uniqueNames.map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-6 mb-3">
          <select
            className="form-select form-control-alternative custom-select w-100"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="">Status</option>
            {uniqueStatuses.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </div>
                <div className="col-md-6 mb-3">
          <Button
            className="w-100"
            onClick={openCalendarModal}
            style={{ 
              height: "38px",
              backgroundColor: "#d86f89",
              borderColor: "#d86f89",
              color: "black"
            }}
          >
            <i className="fas fa-calendar mr-2"></i>
            {selectedCalendarDate ? selectedCalendarDate.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }) : "Select Date"}
          </Button>
        </div>
        <div className="col-md-6 mb-3">
          <Button
            color="secondary"
            size="sm"
            className="w-100"
            onClick={clearAllFilters}
            style={{ 
              height: "38px",
              minWidth: "80px"
            }}
          >
            Clear All Filters
          </Button>
        </div>
      </div>
    </div>

    {/* For all other views (mobile and desktop) keep as-is */}
    <div className="d-md-none d-lg-flex justify-content-between align-items-center flex-wrap">
      <Form className="navbar-search form-inline w-100 mb-3 mb-md-0">
        <FormGroup className="mb-0 w-100">
          <div className="d-flex align-items-center">
            <InputGroup className="input-group-alternative w-70">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="fas fa-search" style={{ color: "black" }} />
                </InputGroupText>
                <Input
                  placeholder="Search Employee"
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-100"
                />
              </InputGroupAddon>
            </InputGroup>
          </div>

          <div
            className="d-flex flex-wrap align-items-center ml-3"
            style={{ gap: "10px" }}
          >
            {/* Filters (Month, Year, Name, Status) */}
            <select
              className="form-select form-control-alternative custom-select"
              value={monthFilter}
              onChange={(e) => setMonthFilter(e.target.value)}
              style={{ minWidth: 120 }}
            >
              <option value=""> Months</option>
              {monthNames.map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </select>
            <select
              className="form-select form-control-alternative custom-select"
              value={yearFilter}
              onChange={(e) => setYearFilter(e.target.value)}
              style={{ minWidth: 120 }}
            >
              <option value="">Years</option>
              {uniqueYears.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
            <select
              className="form-select form-control-alternative custom-select"
              value={nameFilter}
              onChange={(e) => setNameFilter(e.target.value)}
              style={{ minWidth: 120 }}
            >
              <option value="">Employee Names</option>
              {uniqueNames.map((name) => (
                <option key={name} value={name}>
                  {name}
                </option>
              ))}
            </select>
            <select
              className="form-select form-control-alternative custom-select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              style={{ minWidth: 120 }}
            >
              <option value="">Status</option>
              {uniqueStatuses.map((status) => (
                <option key={status} value={status}>
                  {status}
                </option>
              ))}
            </select>
                        <Button
              className="form-control-alternative"
              onClick={openCalendarModal}
              style={{ 
                minWidth: 120, 
                height: "38px",
                backgroundColor: "#d86f89",
                borderColor: "#d86f89",
                color: "black"
              }}
            >
              <i className="fas fa-calendar mr-2"></i>
              {selectedCalendarDate ? selectedCalendarDate.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }) : "Select Date"}
            </Button>
            <Button
              color="secondary"
              size="sm"
              className="form-control-alternative"
              onClick={clearAllFilters}
              style={{ 
                minWidth: 120, 
                height: "38px"
              }}
            >
              Clear All
            </Button>
          </div>
        </FormGroup>
      </Form>
    </div>
  </Col>
</Row>

            </Container>
          </div>
          {/* <h1 className="text-white text-center mb-4">Stock Management</h1> */}

          <Row className="">
  <Col xl="12" style={{ marginTop: "-20px" }}>
    <Card
      style={{
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#fff",
        borderRadius: "15px",
      }}
    >
      <CardBody>
        <CardHeader className="border-0">
          <>
            {/* Mobile & Tablet View */}
            <div className="d-block d-lg-none mb-3 gap-3" style={{marginRight:'50px'}}>
              <div className="text-center mb-2">
                <h3 className="mb-0">Attendance List</h3>
                <small className="text-muted">
                  Showing {filteredData.slice((currentPage - 1) * entriesToShow, currentPage * entriesToShow).length} of {filteredData.length} records
                  {filteredData.length !== attendanceData.length && ` (filtered from ${attendanceData.length} total)`}
                </small>
              </div>
              <div className="d-flex justify-content-between align-items-center gap-3">
  <div style={{ flex: "1 1 48%" }}>
    <button
      className="btn btn-success w-100 py-2 px-2"
      style={{
        backgroundColor: "#d86f89",
        borderColor: "#d86f89",
        color: "black",
        fontSize: "14px",
      }}
      onClick={handleDownload}
    >
      Download
          </button>
    </div>
    
  </div>

            </div>

            {/* Laptop & Desktop View */}
            <Row className="align-items-center d-none d-lg-flex">
              <div className="col">
                <h3 className="mb-0">Attendance List</h3>
                <small className="text-muted">
                  Showing {filteredData.slice((currentPage - 1) * entriesToShow, currentPage * entriesToShow).length} of {filteredData.length} records
                  {filteredData.length !== attendanceData.length && ` (filtered from ${attendanceData.length} total)`}
                </small>
              </div>
              <div className="col text-right d-flex justify-content-end align-items-center">
                <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
                  <DropdownToggle caret className="mr-2">
                    Show Entries: {entriesToShow === filteredData.length ? "All" : entriesToShow}
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem onClick={() => handleEntriesChange(5)}>5</DropdownItem>
                    <DropdownItem onClick={() => handleEntriesChange(10)}>10</DropdownItem>
                    <DropdownItem onClick={() => handleEntriesChange(15)}>15</DropdownItem>
                    <DropdownItem onClick={() => handleEntriesChange(50)}>50</DropdownItem>
                    <DropdownItem onClick={() => handleEntriesChange("All")}>All</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <button
                  className="btn btn-success ml-2"
                  style={{
                    backgroundColor: "#d86f89",
                    borderColor: "#d86f89",
                    color: "black",
                  }}
                  onClick={handleDownload}
                >
                  Download
                </button>
              </div>
            </Row>
          </>
        </CardHeader>

        {/* Table */}
        <Table className="align-items-center table-flush" responsive key={`table-${entriesToShow}-${currentPage}`}>
          <thead className="thead-light">
            <tr>
              <th scope="col">SI.No</th>
              <th scope="col">Employee Name</th>
              <th 
                scope="col" 
                style={{ cursor: "pointer" }}
                onClick={handleDateSort}
                title="Click to sort by date"
              >
                Date {dateSortOrder === "desc" ? "↓" : "↑"}
              </th>
              <th scope="col">Time In</th>
              <th scope="col">Time Out</th>
              <th scope="col">Status</th>
              <th scope="col">Total Hours</th>
            </tr>
          </thead>
          <tbody style={{ textAlign: "center" }}>
            {filteredData && Array.isArray(filteredData) ? (
              filteredData.length > 0 ? (
                filteredData
                  .slice((currentPage - 1) * entriesToShow, currentPage * entriesToShow)
                  .map((item, index) => (
                    <tr key={index}>
                      <th scope="row">{getSerialNumber(index)}</th>
                      <td>{item.emp_name}</td>
                      <td>{formatDate(item.date)}</td>
                      <td>{item.time_in}</td>
                      <td>{item.time_out}</td>
                      <td>{item.status}</td>
                      <td>{item.total_hours}</td>
                    </tr>
                  ))
              ) : (
                <tr>
                  <td colSpan="7" style={{ color: "black", fontWeight: "bold", textAlign: "center" }}>
                    No results found
                  </td>
                </tr>
              )
            ) : (
              <tr>
                <td colSpan="7" style={{ color: "black", fontWeight: "bold", textAlign: "center" }}>
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {/* Pagination */}
        <nav className="mt-3">
          <ul className="pagination justify-content-center">
            <li className="page-item">
              <a
                href="#"
                className="page-link text-primary"
                onClick={prePage}
                disabled={currentPage === 1}
              >
                Prev
              </a>
            </li>
            <li className="page-item">
              <a
                href="#"
                className="page-link text-primary"
                onClick={nextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </a>
            </li>
          </ul>
        </nav>
      </CardBody>
    </Card>
  </Col>
</Row>







        </Container>
      </div>

      {/* Calendar Modal */}
      <Modal isOpen={calendarModalOpen} toggle={closeCalendarModal} size="sm">
        <ModalHeader toggle={closeCalendarModal}>
          Select Date
        </ModalHeader>
        <ModalBody>
          <div className="d-flex justify-content-center">
            <div style={{ width: '100%', maxWidth: 340, minWidth: 0, display: 'flex', justifyContent: 'center' }}>
              <Calendar
                style={{ width: '100%' }}
                onChange={handleCalendarDateChange}
                value={selectedCalendarDate}
                maxDate={new Date()}
              />
            </div>
          </div>
          <div className="mt-3 text-center">
            <small className="text-muted">
              Click on any date to filter attendance records
            </small>
          </div>
          <style>{calendarCustomStyle}</style>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AttendancePage;